import * as pbm from '@/grpc-gen/handlebar_pb';
import ApiHandlebar from '@/model/MessageHandlebar';

export default class Handlebar extends ApiHandlebar {
  static fromGrpcModel(o?: pbm.Handlebar): Handlebar {
    const handlebar = new Handlebar();

    handlebar.id = Number(o?.id ?? 0);
    handlebar.name = o?.name ?? '';
    handlebar.expression = o?.expression ?? '';

    return handlebar;
  }
}
